/**
 * Decodes the HTML entities that the API escapes in a comment body.
 *
 * The function decodes `&amp;` last. An earlier pass would turn an escaped
 * `&amp;lt;` into `<` instead of the literal text `&lt;`.
 */
export const decodeHtmlEntities = (value: string): string =>
  value
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#x27;/g, "'")
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
